import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import CodeIcon from '@mui/icons-material/Code';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import JavascriptIcon from '@mui/icons-material/Javascript';
import '../styles/Footer.css'


const Footer = () => {
  return (
    <div className='footer'>
        <div className='socialMedia'>
            <a href='https://github.com/chetna050699'><GitHubIcon/></a>
            <a href='https://leetcode.com/chetnakumaridps/'><CodeIcon/></a>
            <a href="mailto:chetnakumaridps@gmail.com"><EmailIcon/></a>
            <a href='https://www.linkedin.com/in/chetna-kumari-38139717a/'><LinkedInIcon/></a>
            <a href='https://www.hackerrank.com/chetnakumaridps?hr_r=1'><JavascriptIcon/></a>
        </div>
        <p>&copy; 2023 Chetna Kumari</p>
      
    </div>
  )
}

export default Footer
